import "./InputMultiselectDirective.scss";

import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";
import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";
import InputMultiselectDirectiveController from "./InputMultiselectDirectiveController";

export default class InputMultiselectDirective implements IDirective {
    public controllerAs = "$ctrl";

    public priority = 1000;

    public restrict = "E";

    public required = "ngModel";

    public bindToController = {
        irLabel: "<",
        irOptions: "<",
        irTextField: "<",
        irValueField: "<",
        ngModel: "=",
        ngRequired: "<",
    };

    public scope = {};

    public template: string;

    public controller: Injectable<IControllerConstructor>;

    public link = InputDirectiveFunctions.link; // eslint-disable-line @typescript-eslint/unbound-method

    public compile = InputDirectiveFunctions.compile(this.link);

    constructor() {
        this.controller = InputMultiselectDirectiveController;

        this.template = `
    <ui-select multiple tagging theme="bootstrap"
             class="input-multiselect"
             aa-label="{{$ctrl.irLabel | translate}}"
             on-remove="$ctrl.blur()"
             on-select="$ctrl.blur()"
             aa-field-group="$ctrl.ngModel"
             ng-required="ngRequired">
        <ui-select-match>{{$item[$ctrl.irTextField]}}</ui-select-match>
        <ui-select-choices repeat="option[$ctrl.irValueField] as option in $ctrl.irOptions">
          {{option[$ctrl.irTextField]}}
        </ui-select-choices>
    </ui-select>
    `;
    }
}

module("mmGui").directive("irInputMultiselect", () => new InputMultiselectDirective());
